import setCookie from '../utils/setCookie';

const COOKIE_NAME = 'org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE';

export default (cookieValue) => {
    const date = new Date();
    date.setTime(date.getTime()+(356*24*60*60*1000));

    setCookie({cookieName: COOKIE_NAME, cookieValue, expireDate: date});
}